import { useState } from "react";
import { useParams } from "@tanstack/react-router";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// State
import { useOrderCard } from "../../state/orderCardState";
// Component imports
import { Loading } from "../../components/Loading";
import { GenericListHeader } from "../../components/GenericHeader";
import { OrderAddress } from "./OrderAddress";
import OrderDetails from "./OrderDetails";
import OrderLines from "./OrderLines";
// MUI imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function OrderCard() {
  const { id } = useParams({ strict: false });

  // Store Order Data
  const [order, setOrder] = useState({
    companyAddr: [],
    filter: {},
    order: { no: "", line: [] },
  });

  const { isError, isSuccess, error, data } = useOrderCard(id);

  // Success Function
  const successFunc = () => setOrder(data.data.data.data.data);

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      {order.order?.no ? (
        <Box>
          <GenericListHeader heading={`Order - ${order.order.no}`} />
          <Box sx={{ pt: 1 }}>
            <OrderDetails order={order.order} />
          </Box>
          <Box sx={{ pt: 2 }}>
            <OrderLines
              orderLines={order.order.line}
              currencyCode={order.order?.currencyCode}
            />
          </Box>
          <Box sx={{ pt: 2 }}>
            <OrderAddress order={order.order} />
          </Box>
        </Box>
      ) : (
        <Loading />
      )}
    </>
  );
}
